import {CMSContentType} from '../../../api/club-cms/CMSType';
import {RichTextContent} from './RichTextContent';
import {GalleryComponent} from './GalleryComponent';
import {MapContentComponent} from './MapContentComponent';

export function detailsContentComponent(type) {
  switch (type) {
    case CMSContentType.gallery:
      return GalleryComponent;
    //   return ;
    case CMSContentType.map:
      return MapContentComponent;
    case CMSContentType.richText:
      return RichTextContent;
  }
}



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/details.js